import TransportDeliveryHeader from "./Header";
import "./index.css";
import { useEffect, useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import OutgoingTransport from "./Outgoing";
import IngoingTransport from "./Ingoing";
import { getIngoingOutgoingTotal } from "../../../../apis/Business/IngoingOutgoingTotalApi";
import DropdownAndAutocompleteTransport from "../../../../components/DropdownAutocompleteTransport";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const TransportDeliveryComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  const [transportData, setTransportData] = useState([]);

  useEffect(() => {
    getIngoingOutgoingTotal({
      businessId: businessId,
      setData: setTransportData,
    });
  }, [businessId]);

  const handleScrollToRow = (identifier) => {
    const targetRow = document.getElementById(identifier);
    if (targetRow) {
      targetRow.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };
  return (
    <div className="ingoing-outgoing-container" id="in-out-transport-id">
      <TransportDeliveryHeader businessId={businessId} show={show} />
      {show && (
        <DropdownAndAutocompleteTransport
          data={transportData}
          onResultClick={handleScrollToRow}
        />
      )}
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox isNormal={true} number={"Flow 4"} color={"#193666"} />
        </div>
      </div>
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Ingoing Transport"}
        />
      )}
      {show && <IngoingTransport businessId={businessId} />}
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Outgoing Transport"}
        />
      )}
      {show && <OutgoingTransport businessId={businessId} />}
    </div>
  );
};

export default TransportDeliveryComponent;
